import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ShipmentFilterService } from '../../shared/services/shipment-filter.service';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { FilterAssist } from '../../../models/filter-assist';
import { Observable } from 'rxjs';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { ShipmentQuery } from '../../../models/shipment-query';
import { selectShipmentsTableQuery } from '../../../store/shipments-table/shipments-table.state';
import { filter, map, switchMap } from 'rxjs/operators';
import { shipmentTableAddAssist, shipmentTableRemoveAssist } from '../../../store/shipments-table/shipments-table.actions';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-shipments-table-filter',
    templateUrl: './shipments-table-filter.component.html',
    styleUrls: ['./shipments-table-filter.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatChipGrid, MatChipRow, MatChipRemove, IconComponent, MatInput, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class ShipmentsTableFilterComponent implements OnInit {

    @ViewChild('termsInput') termsInput: ElementRef<HTMLInputElement>;

    public categoryShipmentDate = FilterCategoryEnum.SHIPMENT_DATE;
    public categoryShipper = FilterCategoryEnum.SHIPPER;
    public categoryDestination = FilterCategoryEnum.DESTINATION;
    public categoryStatus = FilterCategoryEnum.STATUS;
    public categoryService = FilterCategoryEnum.SERVICE;
    public categoryBatch = FilterCategoryEnum.BATCH;

    constructor(private shipmentFilterService: ShipmentFilterService, private store: Store<AppState>) {
    }

    searchForm = new UntypedFormGroup({
        terms: new UntypedFormControl('')
    });

    shipmentQuery$: Observable<ShipmentQuery> = this.store.select(selectShipmentsTableQuery);
    activeAssists$: Observable<FilterAssist[]> = this.shipmentQuery$.pipe(
        switchMap((query) => this.shipmentFilterService.activeAssists(query))
    );
    offeredAssists$: Observable<FilterAssist[]> = this.searchForm.valueChanges.pipe(
        map(form => form.terms),
        filter(terms => typeof terms === 'string'),
        switchMap(terms => this.shipmentFilterService.autocompleteTerms(terms))
    );

    ngOnInit(): void {

    }

    onAssistSelection(assist: FilterAssist): void {
        this.store.dispatch(shipmentTableAddAssist({ id: assist.id, parameters: assist.parameter }));
        this.termsInput.nativeElement.value = '';
        this.searchForm.get('terms').setValue('');
    }

    onRemoveAssist(id: string): void {
        this.store.dispatch(shipmentTableRemoveAssist({ id }));
    }

}
